<template>
  <div class="form-workspace">
    <div class="form-palette-bar">
      <span class="palette-label">آیتم</span>
      <button type="button" class="item-chip" :class="'chip-' + entry.type" v-for="entry in itemTypes" :key="entry.type" @click="addQuestion(entry.type)">
        {{ entry.label }}
      </button>
      <span class="palette-sep"></span>
      <button type="button" class="item-chip chip-step" @click="loadInsuranceSample">
        نمونه بیمه ۱۴۰۵
      </button>
      <span class="palette-sep"></span>
      <b-form-checkbox v-model="form.form_questions['answer_without_login']" switch size="sm">
        بدون ثبت‌نام
      </b-form-checkbox>
      <b-form-checkbox v-model="form.form_questions['send_sms_after_answer_for_admin']" switch size="sm">
        پیامک
      </b-form-checkbox>
      <b-form-checkbox v-model="form.form_questions['send_email_after_answer_for_admin']" switch size="sm">
        ایمیل
      </b-form-checkbox>
      <div class="score-box">
        <span class="score-label">امتیاز</span>
        <input type="number" v-model="form.form_questions['total_score']" class="form-control form-control-sm" placeholder="۰">
        <button type="button" class="score-info" v-b-modal.modal-1 aria-label="راهنمای امتیاز">
          <b-icon icon="info-circle-fill"/>
        </button>
      </div>
      <b-modal id="modal-1" hide-footer>
        <div class="text-right" dir="rtl">
          <p>مقدار اگر خالی یا عددی باشد امتیاز محاسبه میشود اما اگر مقدار صفر باشد هیچ امتیازی محاسبه نمیشود.</p>
        </div>
      </b-modal>
    </div>

    <form-flow-chart
      class="mb-2"
      :questions="formQuestions"
      :selected-id="focusedStepId"
      @select-step="focusStep"
    />

    <form-price-formulas
      v-if="form.form_questions && typeof form.form_questions === 'object'"
      :form-questions-root="form.form_questions"
    />

    <div class="step-tabs">
      <div
        v-for="tab in stepTabs"
        :key="tab.key"
        class="step-tab-wrap"
        :class="{ active: tab.key === activeTabKey }"
      >
        <button
          type="button"
          class="step-tab"
          :class="{ active: tab.key === activeTabKey }"
          @click="selectTab(tab)"
        >
          {{ tab.title }}
        </button>
        <div v-if="tab.step" class="step-tab-move">
          <button
            type="button"
            class="step-move-btn"
            title="انتقال به قبل"
            aria-label="انتقال مرحله به قبل"
            :disabled="!canMoveStep(tab, 'prev')"
            @click.stop="moveStep(tab, 'prev')"
          >
            <b-icon icon="chevron-right"/>
          </button>
          <button
            type="button"
            class="step-move-btn"
            title="انتقال به بعد"
            aria-label="انتقال مرحله به بعد"
            :disabled="!canMoveStep(tab, 'next')"
            @click.stop="moveStep(tab, 'next')"
          >
            <b-icon icon="chevron-left"/>
          </button>
        </div>
      </div>
    </div>

    <form-step-paths
      v-if="activeTab && activeTab.step"
      :questions="formQuestions"
      :focus-step-id="focusedStepId"
      :only-step-id="activeTab.key"
      @select-step="focusStep"
    />

    <div class="form-q-list">
      <div
        class="form-q-card"
        :class="'q-type-' + formQuestions[index].type"
        v-for="index in activeIndices"
        :key="index"
      >
          <div class="form-q-main">
          <textarea-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='textarea'"/>
          <radio-box-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='radiobox'"/>
          <select-box-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='selectbox'"/>
          <range-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='range'"/>
          <image-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='image'"/>
          <step-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='step'"/>
          <digital-sign-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='digital_sign'"/>
          <authenticate-phone-meli-code-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]"
                                              v-if="formQuestions[index].type =='authenticated_phone_melicode'"/>
          <select-box-with-filter-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]"
                                        v-if="formQuestions[index].type =='select-box-with-filter'"/>
          <text-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='text'"/>
          <combination-text @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='combination_text'"/>
          <gate-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='gate'"/>
          <form-product-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='form_product'"/>
          <form-address-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='form_address'"/>
          <check-box-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='check_box'"/>
          <category-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='category_input'"/>
          <choose-product-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='choose_product_input'"/>
          <choose-multiple-product-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]"
                                         v-if="formQuestions[index].type =='choose_multiple_product_input'"/>
          <create-shopping-cart-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]"
                                      v-if="formQuestions[index].type =='create_shopping_cart_input'"/>
          <star-input @removeQuestion="removeQuestion(index)" :item="formQuestions[index]" v-if="formQuestions[index].type =='star'"/>

          <div class="item-extra" v-if="formQuestions[index].type !== 'combination_text' && formQuestions[index].type !== 'step'">
            <input
              type="text"
              class="form-control item-var"
              v-model="formQuestions[index].variable"
              placeholder="نام متغیر، مثلا age"
            >
            <input
              type="text"
              class="form-control item-desc"
              v-model="formQuestions[index].description"
              placeholder="توضیحات"
            >
          </div>

          </div>

          <div class="form-q-actions">
            <button
              type="button"
              class="q-btn"
              title="بالا"
              :disabled="!canMoveInTab(index, 'up')"
              @click="moveItem('up', index)"
            >
              <b-icon icon="chevron-up"/>
            </button>
            <button
              type="button"
              class="q-btn"
              title="پایین"
              :disabled="!canMoveInTab(index, 'down')"
              @click="moveItem('down', index)"
            >
              <b-icon icon="chevron-down"/>
            </button>
            <b-dropdown
              v-if="formQuestions[index].type !== 'step' && transferTargets.length"
              variant="link"
              size="sm"
              no-caret
              dropleft
              boundary="viewport"
              toggle-class="q-btn q-transfer-toggle"
            >
              <template slot="button-content">
                <b-icon icon="arrow-left-right"/>
              </template>
              <b-dropdown-header>انتقال به مرحله</b-dropdown-header>
              <b-dropdown-item
                v-for="tab in transferTargets"
                :key="`move-${index}-${tab.key}`"
                @click="transferQuestion(index, tab.key)"
              >
                {{ tab.title }}
              </b-dropdown-item>
            </b-dropdown>
            <button type="button" class="q-btn" title="تنظیمات" v-b-modal="`item-config-${formQuestions[index].id}`">
              <b-icon icon="three-dots"/>
            </button>
            <button type="button" class="q-btn is-danger" title="حذف" @click="removeQuestion(index)">
              <b-icon icon="trash"/>
            </button>
          </div>
          <b-modal :id="`item-config-${formQuestions[index].id}`" hide-footer>
            <div class="text-right" dir="rtl">
              <h4 class="mb-3">{{ formQuestions[index].title }}</h4>
              <div class="form-group">
                <label class="mb-0 mr-2">نام متغیر</label>
                <input v-model="formQuestions[index]['variable']" type="text" class="form-control" placeholder="مثلا age">
                <small class="text-muted d-block mt-1">در شرط و فرمول قیمت به صورت «نام متغیر · نام مرحله» دیده می‌شود تا سن موتور با سن سواری قاطی نشود.</small>
              </div>
              <div class="form-group">
                <label class="mb-0 mr-2">توضیحات</label>
                <input v-model="formQuestions[index]['description']" type="text" class="form-control">
              </div>
              <div class="form-group">
                <label class="mb-0 mr-2">placeholder</label>
                <input v-model="formQuestions[index]['placeholder']" type="text" class="form-control">
              </div>
              <b-form-checkbox
                :checked="formQuestions[index].required !== false"
                @change="value => $set(formQuestions[index], 'required', value)"
                switch
              >
                اجباری
              </b-form-checkbox>
            </div>
          </b-modal>
      </div>
      <p v-if="!activeIndices.length" class="empty-tab">در این مرحله هنوز سؤالی نیست. از نوار بالا آیتم اضافه کن.</p>
    </div>
  </div>
</template>

<script>
import TextareaInput from "./components/TextareaInput.vue";
import RadioBoxInput from "./components/RadioBoxInput.vue";
import SelectBoxInput from "./components/SelectBoxInput.vue";
import RangeInput from "./components/RangeInput.vue";
import ImageInput from "./components/ImageInput.vue";
import SelectBoxWithFilterInput from "./components/SelectBoxWithFilterInput.vue";
import TextInput from "./components/TextInput.vue";
import StepInput from "./components/StepInput.vue";
import DigitalSignInput from "./components/DigitalSignInput.vue";
import AuthenticatePhoneMeliCodeInput from "./components/AuthenticatePhoneMeliCodeInput.vue";
import CombinationText from "./components/CombinationText.vue";
import GateInput from "./components/GateInput.vue";
import FormProductInput from "./components/FormProductInput.vue";
import FormAddressInput from "./components/FormAddressInput.vue";
import CheckBoxInput from "./components/CheckBoxInput.vue";
import CategoryInput from "./components/CategoryInput.vue";
import ChooseProductInput from "./components/ChooseProductInput.vue";
import ChooseMultipleProductInput from "./components/ChooseMultipleProductInput.vue";
import CreateShoppingCartInput from "./components/CreateShoppingCartInput.vue";
import StarInput from "./components/StarInput.vue";
import FormStepPaths from "./components/FormStepPaths.vue";
import FormFlowChart from "./components/FormFlowChart.vue";
import FormPriceFormulas from "./components/FormPriceFormulas.vue";
import {ensurePriceConfig} from "./formQuestionContext";
import {thirdPartyInsurance1405Form} from "./samples/thirdPartyInsurance1405";

export default {
  name: "CreateFormJson",
  components: {
    FormStepPaths,
    FormFlowChart,
    FormPriceFormulas,
    CreateShoppingCartInput,
    StarInput,
    ChooseMultipleProductInput,
    ChooseProductInput,
    CategoryInput,
    CheckBoxInput,
    FormAddressInput,
    FormProductInput,
    CombinationText,
    RadioBoxInput,
    TextareaInput,
    SelectBoxInput,
    RangeInput,
    ImageInput,
    SelectBoxWithFilterInput,
    TextInput,
    StepInput,
    DigitalSignInput,
    AuthenticatePhoneMeliCodeInput,
    GateInput
  },
  props: {
    form: {}
  },
  data() {
    return {
      focusedStepId: null,
      activeTabKey: 'start',
      itemTypes: [
        {type: 'textarea', label: 'متن'},
        {type: 'radiobox', label: 'گزینه‌ای'},
        {type: 'selectbox', label: 'کشویی'},
        {type: 'range', label: 'دامنه'},
        {type: 'image', label: 'عکس'},
        {type: 'select-box-with-filter', label: 'کشویی فیلتر'},
        {type: 'text', label: 'متن کوتاه'},
        {type: 'step', label: 'مرحله'},
        {type: 'authenticated_phone_melicode', label: 'تلفن و کدملی'},
        {type: 'digital_sign', label: 'امضا'},
        {type: 'combination_text', label: 'متن ترکیبی'},
        {type: 'gate', label: 'درگاه'},
        {type: 'form_product', label: 'محصول فرم'},
        {type: 'form_address', label: 'آدرس'},
        {type: 'check_box', label: 'چندانتخابی'},
        {type: 'category_input', label: 'دسته'},
        {type: 'choose_product_input', label: 'انتخاب محصول'},
        {type: 'choose_multiple_product_input', label: 'چند محصول'},
        {type: 'create_shopping_cart_input', label: 'سبد خرید'},
        {type: 'star', label: 'ستاره'}
      ]
    }
  },
  computed: {
    formQuestions() {
      if (this.form.form_questions != '') {
        const questions = this.form.form_questions['form'] || []
        questions.forEach((item) => {
          if (typeof item.required === 'undefined') {
            this.$set(item, 'required', true)
          }
          if (item.type !== 'step' && typeof item.variable === 'undefined') {
            this.$set(item, 'variable', item.slug || '')
          }
          if (Array.isArray(item.options)) {
            item.options.forEach(option => {
              if (typeof option.price === 'undefined') {
                this.$set(option, 'price', '')
              }
            })
          }
        })
        if (!this.form.form_questions.price) {
          this.$set(this.form.form_questions, 'price', {enabled: false, default_formula: '', value_source: 'option_price', rules: []})
        } else {
          ensurePriceConfig(this.form.form_questions)
        }
        return questions
      }
      this.form.form_questions = {form: [], total_score: null, price: {enabled: false, default_formula: '', value_source: 'option_price', rules: []}}
      return this.form.form_questions['form']
    },
    stepTabs() {
      const tabs = []
      let current = {key: 'start', title: 'شروع', step: null, indices: []}
      this.formQuestions.forEach((item, index) => {
        if (item.visibility === false) {
          return
        }
        if (item.type === 'step') {
          if (current.step || current.indices.length) {
            if (current.key !== 'start' || current.indices.length) {
              tabs.push(current)
            }
          }
          current = {
            key: String(item.id),
            title: item.title || `مرحله ${item.id}`,
            step: item,
            indices: [index]
          }
          return
        }
        current.indices.push(index)
      })
      if (current.step || current.indices.length) {
        if (current.key !== 'start' || current.indices.length) {
          tabs.push(current)
        }
      }
      if (!tabs.length) {
        tabs.push({key: 'start', title: 'شروع', step: null, indices: []})
      }
      return tabs
    },
    activeTab() {
      return this.stepTabs.find(tab => tab.key === String(this.activeTabKey)) || this.stepTabs[0]
    },
    activeIndices() {
      return this.activeTab ? this.activeTab.indices : []
    },
    tabQuestionIndices() {
      return this.activeIndices.filter(index => {
        const item = this.formQuestions[index]
        return item && item.type !== 'step' && item.visibility !== false
      })
    },
    transferTargets() {
      return this.stepTabs.filter(tab => tab.key !== String(this.activeTabKey))
    },
    moveableStepTabs() {
      return this.stepTabs.filter(tab => tab.step)
    }
  },
  watch: {
    stepTabs: {
      immediate: true,
      handler(tabs) {
        if (!tabs.some(tab => tab.key === String(this.activeTabKey))) {
          this.activeTabKey = tabs[0].key
          this.focusedStepId = tabs[0].step ? tabs[0].step.id : null
        }
      }
    }
  },
  methods: {
    focusStep(step) {
      this.focusedStepId = step && step.id
      if (step && step.id !== undefined && step.id !== null) {
        this.activeTabKey = String(step.id)
      }
    },
    selectTab(tab) {
      this.activeTabKey = tab.key
      this.focusedStepId = tab.step ? tab.step.id : null
    },
    loadInsuranceSample() {
      if (!confirm('فرم فعلی با نمونه کامل بیمه شخص ثالث ۱۴۰۵ جایگزین می‌شود. ادامه می‌دهی؟')) {
        return
      }
      const clone = JSON.parse(JSON.stringify(thirdPartyInsurance1405Form))
      this.$set(this.form, 'form_questions', clone)
      this.activeTabKey = '1'
      this.focusedStepId = 1
      this.$forceUpdate()
    },
    stepBlockRange(tab) {
      const list = this.formQuestions
      if (!tab || !tab.step) {
        const firstStep = list.findIndex(question => (
          question.type === 'step' && question.visibility !== false
        ))
        return {start: 0, len: firstStep === -1 ? list.length : firstStep}
      }
      const start = list.findIndex(question => (
        question.type === 'step' && String(question.id) === String(tab.step.id)
      ))
      if (start < 0) {
        return {start: 0, len: 0}
      }
      let end = start + 1
      while (end < list.length) {
        const question = list[end]
        if (question.visibility !== false && question.type === 'step') {
          break
        }
        end += 1
      }
      return {start, len: end - start}
    },
    canMoveStep(tab, mode) {
      if (!tab || !tab.step) {
        return false
      }
      const tabs = this.moveableStepTabs
      const position = tabs.findIndex(item => item.key === tab.key)
      if (position < 0) {
        return false
      }
      if (mode === 'prev') {
        return position > 0
      }
      return position < tabs.length - 1
    },
    moveStep(tab, mode) {
      if (!this.canMoveStep(tab, mode)) {
        return
      }
      const tabs = this.moveableStepTabs
      const position = tabs.findIndex(item => item.key === tab.key)
      const neighbor = tabs[mode === 'prev' ? position - 1 : position + 1]
      const from = this.stepBlockRange(tab)
      const to = this.stepBlockRange(neighbor)
      const list = this.formQuestions
      const moving = list.splice(from.start, from.len)
      const insertAt = mode === 'next'
        ? to.start + to.len - from.len
        : to.start
      list.splice(insertAt, 0, ...moving)
      this.activeTabKey = tab.key
      this.focusedStepId = tab.step.id
      this.$forceUpdate()
    },
    insertIndexForNewItem(isStep) {
      const tab = this.activeTab
      if (!tab || !tab.indices.length) {
        return this.formQuestions.length
      }
      if (isStep) {
        return tab.indices[tab.indices.length - 1] + 1
      }
      return tab.indices[tab.indices.length - 1] + 1
    },
    insertQuestion(baseObject, isStep) {
      if (!isStep && typeof baseObject.variable === 'undefined') {
        baseObject.variable = ''
      }
      const at = this.insertIndexForNewItem(isStep)
      this.formQuestions.splice(at, 0, baseObject)
      if (isStep) {
        this.activeTabKey = String(baseObject.id)
        this.focusedStepId = baseObject.id
      }
      this.$forceUpdate()
    },
    removeQuestion(index) {
      const item = this.formQuestions[index]
      if (!item) {
        return
      }
      if (!confirm('آیا از حذف این آیتم اطمینان دارید؟')) {
        return
      }
      this.$set(item, 'visibility', false)
      if (item.type === 'step') {
        this.clearStepPointers(item.id)
        if (String(this.activeTabKey) === String(item.id)) {
          const remaining = this.stepTabs.find(tab => String(tab.key) !== String(item.id))
          this.activeTabKey = remaining ? remaining.key : 'start'
          this.focusedStepId = remaining && remaining.step ? remaining.step.id : null
        }
      }
      this.$forceUpdate()
    },
    clearStepPointers(stepId) {
      const id = String(stepId)
      this.formQuestions.forEach(question => {
        if (!question.config || !question.config.next) {
          return
        }
        if (String(question.config.next.default) === id) {
          this.$set(question.config.next, 'default', '')
        }
        const rules = question.config.next.rules || []
        rules.forEach(rule => {
          if (String(rule.next) === id) {
            this.$set(rule, 'next', '')
          }
        })
      })
    },
    canMoveInTab(index, mode) {
      const item = this.formQuestions[index]
      if (item && item.type === 'step') {
        const tab = this.stepTabs.find(entry => entry.step && String(entry.step.id) === String(item.id))
        return this.canMoveStep(tab, mode === 'up' ? 'prev' : 'next')
      }
      if (!item) {
        return false
      }
      const position = this.tabQuestionIndices.indexOf(index)
      if (position < 0) {
        return false
      }
      if (mode === 'up') {
        return position > 0
      }
      return position < this.tabQuestionIndices.length - 1
    },
    moveItem(mode, index) {
      const item = this.formQuestions[index]
      if (item && item.type === 'step') {
        const tab = this.stepTabs.find(entry => entry.step && String(entry.step.id) === String(item.id))
        this.moveStep(tab, mode === 'up' ? 'prev' : 'next')
        return
      }
      if (!this.canMoveInTab(index, mode)) {
        return
      }
      const bounds = this.tabQuestionIndices
      const position = bounds.indexOf(index)
      const target = mode === 'up' ? bounds[position - 1] : bounds[position + 1]
      const list = this.formQuestions
      list.splice(target, 1, list.splice(index, 1, list[target])[0])
      this.$forceUpdate()
    },
    insertAfterStepRange(destKey) {
      const destTab = this.stepTabs.find(tab => tab.key === String(destKey))
      if (!destTab) {
        return this.formQuestions.length
      }
      if (!destTab.step) {
        const firstStep = this.formQuestions.findIndex(question => (
          question.type === 'step' && question.visibility !== false
        ))
        return firstStep === -1 ? this.formQuestions.length : firstStep
      }
      const stepIndex = this.formQuestions.findIndex(question => (
        question.type === 'step' && String(question.id) === String(destTab.step.id)
      ))
      if (stepIndex < 0) {
        return this.formQuestions.length
      }
      let cursor = stepIndex + 1
      while (cursor < this.formQuestions.length) {
        const question = this.formQuestions[cursor]
        if (question.visibility !== false && question.type === 'step') {
          break
        }
        cursor += 1
      }
      return cursor
    },
    transferQuestion(index, destKey) {
      const item = this.formQuestions[index]
      if (!item || item.type === 'step' || !destKey) {
        return
      }
      if (String(destKey) === String(this.activeTabKey)) {
        return
      }
      const [moved] = this.formQuestions.splice(index, 1)
      const insertAt = this.insertAfterStepRange(destKey)
      this.formQuestions.splice(insertAt, 0, moved)
      this.activeTabKey = String(destKey)
      const destTab = this.stepTabs.find(tab => tab.key === String(destKey))
      this.focusedStepId = destTab && destTab.step ? destTab.step.id : null
      this.$forceUpdate()
    },
    addQuestion(item) {
      let formItemsId = this.formQuestions
          .map(item => Number(item.id))
          .filter(id => !isNaN(id))
      let largestNumber = formItemsId.length === 0 ? 1 : Math.max(...formItemsId)
      let formQuestionLength = largestNumber + 1

      let radioBox = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "radiobox",
        "required": true,
        "placeholder": "",
        "options": [
          {
            "id": "1",
            "label": "ایتم 1",
            "value": 1
          },
        ]
      }

      let textarea = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "textarea",
        "required": true,
        "placeholder": ""
      }

      let selectbox = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "selectbox",
        "required": true,
        "placeholder": "",
        "options": [
          {
            "id": "1",
            "label": "ایتم 1",
            "value": 1
          },
        ]
      }

      let check_box = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "check_box",
        "required": true,
        "placeholder": "",
        "options": [
          {
            "id": "1",
            "label": "ایتم 1",
            "value": 1
          },
        ]
      }

      let range = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "range",
        "required": true,
        "placeholder": "",
        "config": {
          "min": '0',
          "max": '100',
          "step": "1"
        }
      }

      let image = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "image",
        "required": true,
        "placeholder": "",
        "config": {
          "image": ""
        }
      }

      let selectBoxWithFilterInput = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "select-box-with-filter",
        "required": true,
        "placeholder": "",
        "options": [
          {
            "id": "1",
            "label": "ایتم 1",
            "value": 1
          },
        ]
      }

      let text = {
        "id": formQuestionLength,
        "title": `سوال ${formQuestionLength}`,
        "description": "",
        "type": "text",
        "required": true,
        "placeholder": "",
        "config": {
          "pattern": ""
        }
      }

      let step = {
        "id": formQuestionLength,
        "title": `مرحله ${formQuestionLength}`,
        "description": "",
        "type": "step",
        "required": true,
        "placeholder": "",
        "config": {
          "send_sms_after_answer": false,
          'admin_approval': false,
          'send_sms_after_admin_approval': false,
          "next": {
            "default": "",
            "rules": []
          }
        }
      }

      let digitalSign = {
        "id": formQuestionLength,
        "title": `${formQuestionLength}`,
        "description": "",
        "type": "digital_sign",
        "required": true,
        "placeholder": "",
        "config": {
          "verify_with_sms": false,
          'digital_sign_handwrite': false,
          'digital_sign_image': false,
        }
      }

      let authenticated_phone_melicode = {
        "id": formQuestionLength,
        "title": `تایید انطباق تلفن و کدملی`,
        "description": "",
        "type": "authenticated_phone_melicode",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let combination_text = {
        "id": formQuestionLength,
        "title": `متن ترکیبی`,
        "description": "",
        "type": "combination_text",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let gate = {
        "id": formQuestionLength,
        "title": `درگاه`,
        "description": "",
        "type": "gate",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let formProduct = {
        "id": formQuestionLength,
        "title": `یک محصول انتخاب کنید.`,
        "description": "",
        "type": "form_product",
        "required": true,
        "placeholder": "",
        "config": {
          "skip_address": false
        }
      }

      let formAddress = {
        "id": formQuestionLength,
        "title": `آدرس`,
        "description": "",
        "type": "form_address",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let formCategory = {
        "id": formQuestionLength,
        "title": `دسته بندی`,
        "description": "",
        "type": "category_input",
        "required": true,
        "placeholder": "",
        "config": {}
      }


      let choose_product_input = {
        "id": formQuestionLength,
        "title": `انتخاب محصول`,
        "description": "",
        "type": "choose_product_input",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let choose_multiple_product_input = {
        "id": formQuestionLength,
        "title": `انتخاب چند محصول`,
        "description": "",
        "type": "choose_multiple_product_input",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let create_shopping_cart_input = {
        "id": formQuestionLength,
        "title": `ساخت سبد با محصولات انتخابی`,
        "description": "",
        "type": "create_shopping_cart_input",
        "required": true,
        "placeholder": "",
        "config": {}
      }

      let star = {
        "id": formQuestionLength,
        "title": `امتیاز`,
        "description": "",
        "type": "star",
        "required": true,
        "placeholder": "",
        "config": {
          "min": 1,
          "max": 5
        }
      }


      if (item == 'radiobox') {
        let baseObject = Object.assign({}, radioBox)
        this.insertQuestion(baseObject, item === 'step')
      }
      if (item == 'textarea') {
        let baseObject = Object.assign({}, textarea)
        this.insertQuestion(baseObject, item === 'step')
      }
      if (item == 'selectbox') {
        let baseObject = Object.assign({}, selectbox)
        this.insertQuestion(baseObject, item === 'step')
      }
      if (item == 'range') {
        let baseObject = Object.assign({}, range)
        this.insertQuestion(baseObject, item === 'step')
      }
      if (item == 'image') {
        let baseObject = Object.assign({}, image)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'text') {
        let baseObject = Object.assign({}, text)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'select-box-with-filter') {
        let baseObject = Object.assign({}, selectBoxWithFilterInput)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'step') {
        let baseObject = Object.assign({}, step)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'digital_sign') {
        let baseObject = Object.assign({}, digitalSign)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'authenticated_phone_melicode') {
        let baseObject = Object.assign({}, authenticated_phone_melicode)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'combination_text') {
        let baseObject = Object.assign({}, combination_text)
        this.insertQuestion(baseObject, item === 'step')
      }
      if (item == 'gate') {
        let baseObject = Object.assign({}, gate)
        this.insertQuestion(baseObject, item === 'step')
      }
      if (item == 'form_product') {
        let baseObject = Object.assign({}, formProduct)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'form_address') {
        let baseObject = Object.assign({}, formAddress)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'check_box') {
        let baseObject = Object.assign({}, check_box)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'category_input') {
        let baseObject = Object.assign({}, formCategory)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'choose_product_input') {
        let baseObject = Object.assign({}, choose_product_input)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'choose_multiple_product_input') {
        let baseObject = Object.assign({}, choose_multiple_product_input)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'create_shopping_cart_input') {
        let baseObject = Object.assign({}, create_shopping_cart_input)
        this.insertQuestion(baseObject, item === 'step')
      }

      if (item == 'star') {
        let baseObject = Object.assign({}, star)
        this.insertQuestion(baseObject, item === 'step')
      }
    }
  }
}
</script>


<style scoped>
.form-workspace {
  width: 100%;
}

.form-palette-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  background: #fff;
  border: 1px solid #ece7e4;
  border-radius: 12px;
  padding: 8px 10px;
  margin-bottom: 10px;
  position: sticky;
  top: 0;
  z-index: 40;
  box-shadow: 0 10px 22px rgba(30, 30, 30, 0.08);
}

.palette-label {
  font-size: 12px;
  color: #6b7280;
  margin-left: 4px;
}

.item-chip {
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  line-height: 1.4;
  cursor: pointer;
}

.item-chip:hover {
  border-color: #0f766e;
  color: #0f766e;
}

.chip-step { color: #0f766e; border-color: #cce3e0; background: #f3faf9; }
.chip-textarea { color: #2563eb; border-color: #dbe7fb; background: #f5f8ff; }
.chip-text { color: #0284c7; border-color: #cfeaf7; background: #f3faff; }
.chip-selectbox, .chip-select-box-with-filter { color: #7c3aed; border-color: #e4d7fb; background: #f8f5ff; }
.chip-radiobox { color: #d97706; border-color: #f5e0c3; background: #fffaf2; }
.chip-check_box { color: #16a34a; border-color: #ccebd6; background: #f3fbf6; }
.chip-range { color: #0891b2; border-color: #c7eaf1; background: #f3fbfd; }
.chip-image { color: #db2777; border-color: #f6d0e3; background: #fdf5f9; }
.chip-star { color: #ca8a04; border-color: #f3e2b3; background: #fffbeb; }

.palette-sep {
  width: 1px;
  height: 22px;
  background: #e5e7eb;
  margin: 0 4px;
}

.score-box {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f3f7f6;
  border: 1px solid #d7e5e2;
  border-radius: 999px;
  padding: 3px 4px 3px 6px;
  font-size: 12px;
  color: #0f766e;
}

.score-label {
  padding: 0 4px 0 6px;
  font-weight: 600;
  white-space: nowrap;
}

.score-box input {
  width: 64px;
  height: 26px;
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 999px;
  padding: 0 8px;
  text-align: center;
}

.score-info {
  width: 26px;
  height: 26px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #0f766e;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
}

.step-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.step-tab-wrap {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 2px 4px 2px 6px;
}

.step-tab-wrap.active {
  background: #0f766e;
  border-color: #0f766e;
}

.step-tab {
  border: 0;
  background: transparent;
  color: #374151;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 13px;
  cursor: pointer;
}

.step-tab.active {
  background: transparent;
  border-color: transparent;
  color: #fff;
}

.step-tab-move {
  display: inline-flex;
  align-items: center;
}

.step-move-btn {
  width: 22px;
  height: 22px;
  border: 0;
  background: transparent;
  color: #9ca3af;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
}

.step-tab-wrap.active .step-move-btn {
  color: rgba(255, 255, 255, 0.8);
}

.step-move-btn:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.06);
  color: #374151;
}

.step-tab-wrap.active .step-move-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}

.step-move-btn:disabled {
  opacity: 0.28;
  cursor: default;
}

.empty-tab {
  color: #6b7280;
  font-size: 13px;
  margin: 8px 0 0;
}

.form-q-list {
  background: #faf8f6;
  border: 1px solid #eee8e3;
  border-radius: 14px;
  padding: 10px;
}

.form-q-card {
  --q-accent: #78716c;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid #efeae6;
  border-right: 3px solid var(--q-accent);
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 8px;
  background: #fff;
}

.form-q-card:last-child {
  margin-bottom: 0;
}

.form-q-main {
  flex: 1 1 auto;
  min-width: 0;
}

.item-extra {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.item-var {
  flex: 0 0 180px;
  max-width: 200px;
}

.item-desc {
  display: block;
  flex: 1 1 220px;
  margin-top: 0;
  max-width: none;
  width: 100%;
}

.form-q-actions {
  position: static;
  display: inline-flex;
  flex-direction: row;
  flex-shrink: 0;
  align-items: center;
  gap: 2px;
  margin: 0;
  padding: 2px;
  background: #f6f3f0;
  border-radius: 999px;
}

.q-btn {
  width: 28px;
  height: 28px;
  border: 0;
  background: transparent;
  color: #a8a29e;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
}

.q-btn:hover {
  background: #fff;
  color: #44403c;
}

.q-btn.is-danger:hover {
  background: #fff1f0;
  color: #b42318;
}

.q-btn:disabled {
  opacity: 0.28;
  cursor: default;
  pointer-events: none;
}

.form-q-actions >>> .q-transfer-toggle {
  width: 28px;
  height: 28px;
  padding: 0 !important;
  margin: 0;
  border: 0 !important;
  box-shadow: none !important;
  color: #a8a29e !important;
  background: transparent !important;
  line-height: 1;
}

.form-q-actions >>> .q-transfer-toggle:hover,
.form-q-actions >>> .q-transfer-toggle:focus {
  color: #44403c !important;
  background: #fff !important;
}

.form-q-actions >>> .dropdown-menu {
  min-width: 160px;
  font-size: 13px;
  text-align: right;
}

.q-type-step { --q-accent: #0f766e; }
.q-type-textarea { --q-accent: #2563eb; }
.q-type-text { --q-accent: #0284c7; }
.q-type-selectbox { --q-accent: #7c3aed; }
.q-type-select-box-with-filter { --q-accent: #6d28d9; }
.q-type-radiobox { --q-accent: #d97706; }
.q-type-check_box { --q-accent: #16a34a; }
.q-type-range { --q-accent: #0891b2; }
.q-type-image { --q-accent: #db2777; }
.q-type-star { --q-accent: #ca8a04; }
.q-type-digital_sign { --q-accent: #4f46e5; }
.q-type-authenticated_phone_melicode { --q-accent: #0d9488; }
.q-type-combination_text { --q-accent: #57534e; }
.q-type-gate { --q-accent: #dc2626; }
.q-type-form_product { --q-accent: #ea580c; }
.q-type-form_address { --q-accent: #65a30d; }
.q-type-category_input { --q-accent: #9333ea; }
.q-type-choose_product_input { --q-accent: #c2410c; }
.q-type-choose_multiple_product_input { --q-accent: #b45309; }
.q-type-create_shopping_cart_input { --q-accent: #be123c; }

.form-q-list >>> .item-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 10px;
}

.form-q-list >>> .item-meta {
  gap: 14px;
  margin-top: 8px;
}

.form-q-list >>> .title-input {
  flex: 0 0 180px !important;
  max-width: 200px !important;
  width: 180px !important;
}

.form-q-list >>> .opt-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.form-q-list >>> .opt-row {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 6px;
  margin-top: 0;
  background: #faf8f6;
  border: 1px solid #efeae6;
  border-radius: 10px;
  padding: 4px 8px;
}

.form-q-list >>> .opt-row .form-control {
  flex: 0 0 160px !important;
  width: 160px !important;
  max-width: 180px !important;
  background: #fff;
}

.form-q-list >>> .opt-row .opt-price {
  flex: 0 0 110px !important;
  width: 110px !important;
  max-width: 120px !important;
}

.form-q-list >>> .form-group {
  margin-bottom: 8px;
}

.form-q-list >>> .form-control {
  height: 34px;
  padding: 5px 10px;
  font-size: 13px;
  color: #3f3a36;
  background: #faf9f7;
  border: 1px solid #ebe6e1;
  border-radius: 8px;
  box-shadow: none;
}

.form-q-list >>> .form-control:focus {
  background: #fff;
  border-color: color-mix(in srgb, var(--q-accent) 45%, #ebe6e1);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--q-accent) 14%, transparent);
}

.form-q-list >>> textarea.form-control[disabled] {
  display: none;
}

.form-q-list >>> .badge {
  font-size: 11px;
  font-weight: 500;
  padding: 3px 8px;
  margin: 0 !important;
  border: 0;
}

.form-q-list >>> .badge-warning {
  background: color-mix(in srgb, var(--q-accent) 12%, #fff);
  color: var(--q-accent);
}

.form-q-list >>> .badge-light {
  background: transparent;
  color: #b3aba3;
  border: 1px solid #eee9e4;
}

.form-q-list >>> .type-chip {
  background: color-mix(in srgb, var(--q-accent) 12%, #fff);
  color: var(--q-accent);
}

.form-q-list >>> .mini-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b635c;
}

.form-q-list >>> .mini-check input {
  margin: 0;
  accent-color: var(--q-accent);
}

.form-q-list >>> .item-head .bg-danger {
  display: none;
}

.form-q-list >>> .item-head .bg-primary {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px;
  min-height: 36px;
  font-size: 22px !important;
  background: var(--q-accent) !important;
  color: #fff !important;
  border-radius: 10px !important;
  padding: 6px !important;
  box-sizing: border-box !important;
  cursor: pointer;
  flex: 0 0 36px;
}

.form-q-list >>> .opt-row .text-danger {
  color: #c4bdb6 !important;
  cursor: pointer;
}

.form-q-list >>> .h3,
.form-q-list >>> .h4 {
  font-size: 16px;
  margin: 0 4px;
}

.form-q-list >>> .my-3,
.form-q-list >>> .my-2 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}
</style>